<div class="version-badge-container">
  <button
    type="button"
    class="version-badge-btn"
    (click)="toggle($event)"
    [attr.aria-expanded]="isOpen"
  >
   <div class="w-100 d-flex justify-content-around"> <span class="version-label">{{ data?.label }}</span>
    <span class="version-active-pill">Active</span>
  </div>
    <img
      src="assets/images/virtusa-icons/drop-arrow.svg"
      alt=""
      class="drop-arrow"
      [class.drop-arrow--open]="isOpen"
    />
  </button>

  <div
    class="version-dropdown-panel"
    *ngIf="isOpen && data?.tree?.length"
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
  >
    <ng-container *ngFor="let node of data!.tree">
      <!-- Parent row -->
      <button type="button" class="ver-row" (click)="toggleNode($event, node)">
        <i
          *ngIf="node.children?.length"
          class="bi ver-toggle"
          [class.bi-chevron-right]="!isExpanded(node)"
          [class.bi-chevron-down]="isExpanded(node)"
        ></i>
        <span *ngIf="!node.children?.length" class="ver-spacer"></span>
        <span class="ver-label">{{ node.displayName }}</span>
        <span
          *ngIf="node.badge"
          class="ver-badge"
          [class.ver-badge--active]="node.badge.variant === 'active'"
        >{{ node.badge.text }}</span>
      </button>

      <!-- Children (one level deep) -->
      <ng-container *ngIf="isExpanded(node) && node.children?.length">
        <button
          type="button"
          class="ver-row ver-row--child"
          *ngFor="let child of node.children"
          (click)="$event.stopPropagation()"
        >
          <span class="ver-spacer"></span>
          <span class="ver-label">{{ child.displayName }}</span>
          <span
            *ngIf="child.badge"
            class="ver-badge"
            [class.ver-badge--active]="child.badge.variant === 'active'"
          >{{ child.badge.text }}</span>
        </button>
      </ng-container>
    </ng-container>
  </div>
</div>
